import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=11a36bb2&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=11a36bb2&prod&lang=css&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=11a36bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a36bb2",
  null
  
)

export default component.exports